<template lang="html">
  <b-container id="view-Role">
    <div>
      <b-row>
        <b-col>
          <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
            <h5>{{alertItem}}!</h5>
          </b-alert>
          <b-row>
          <b-col>
          <b-card class="role-info">
            <b-row>
              <b-col>
                <h1 v-translate>Role</h1>
                <b-form @submit.prevent="updateRole(role.id)">
                  <b-form-row>
                    <div class="form-group col-sm-8">
                      <label for="change-status" v-translate>Role name</label>
                      <div class="input-group">
                        <b-form-input v-model="role.name" type="text" required />
                      </div>
                    </div>
                    <div class="form-group col-12 form-actions">
                      <label class="col-md-3 control-label"></label>
                      <div class="col-md-8">
                        <b-button type="submit" variant="secondary" size="lg" v-translate>Save Changes</b-button>
                      </div>
                    </div>
                  </b-form-row>
                </b-form>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col>
          <b-card class="role-permissions">
            <b-row>
              <b-col>
                <h3 v-translate>Role Permissions <small>(realtime change)</small></h3>
                <div v-for="permission in permissions" :key="permission.id">
                  <b-form-checkbox
                    v-model="permissionsSelected"
                    :key="permission.id"
                    :value="permission.id"
                    class="cols-12"
                    @change="changePermission(permission.id)"
                  >
                  {{ permission.name }}
                  </b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  data() {
    return {
      dismissSecs: 5,
      dismissCountDown: 0,
      searchQuery: '',
      permissions: [],
      permissionsSelected: [],
      role: {},
      alertItem: ''
    }
  },
  created() {
    this.fetchPermissions()
  },
  mounted() {

  },
  methods: {
    fetchRole() {
      this.$http.get(this.$appConfig.api.baseUrl + 'roles/' + this.$route.params.id + '?includes[]=permissions')
        .then(response => {
          console.log(response.body)
          this.role = response.body
          this.permissionsSelected = this.role.permissions.map((permission) => {
            return permission.id
          })
        })
    },
    updateRole() {
      this.$http.patch(this.$appConfig.api.baseUrl + 'roles/' + this.$route.params.id, this.role)
        .then(response => {
          setTimeout(function () {
            this.showAlert(this.$gettext('Role was updated!'))
            this.fetchRole()
          }.bind(this), 500)
        })
    },
    fetchPermissions(page) {
      page = page || 0
      this.$http.get(this.$appConfig.api.baseUrl + 'permissions?page=' + page + '&limit=100&sort%5B0%5D%5Bkey%5D=name&sort%5B0%5D%5Bdirection%5D=asc')
        .then(response => {
          console.log(response.body)
          this.permissions = this.permissions.concat(response.body.data)
          if (this.permissions.length < response.body.pagination.total) {
            page++
            this.fetchPermissions(page)
          } else {
            this.fetchRole()
          }
        })
    },
    changePermission(permission) {
      this.$nextTick(() => {
        if (this.permissionsSelected.indexOf(permission) !== -1) {
          this.$http.post(this.$appConfig.api.baseUrl + 'roles/' + this.$route.params.id + '/permissions', [permission])
            .then(response => {
              console.log('ON')
              console.log(response)
              this.showAlert(this.$gettext('Permission has been set ON!'))
            })
        } else {
          this.$http.delete(this.$appConfig.api.baseUrl + 'roles/' + this.$route.params.id + '/permissions', {body: [permission]})
            .then(response => {
              console.log('OFF')
              console.log(response)
              this.showAlert(this.$gettext('Permission has been set OFF!'))
            })
        }
        console.log(permission)
      })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert(msg) {
      this.alertItem = msg
      this.dismissCountDown = this.dismissSecs
    }
  }
}
</script>
